module.exports = __webpack_public_path__ + "img/user.7dd22aea.svg";